import { useEffect } from "react";
import useCompanyItem from "../../useCompanyItem";
import BPDocumentItem from "./BPDocumentItem/BPDocumentItem";
import useCompanyDocuments from "./useCompanyDocuments";
import SaveBtn from "../../../../../../../../common/SaveBtn";
import tools from "../../../../../../../../../helpers/tools";
import DERForm from "./DERForm";
import { modalActions } from "../../../../../../../../../context/actions/modalActions";
import useStore from "../../../../../../../../../context/useStore";

const BPDocuments = ({ docType }) => {
  const { company } = useCompanyItem();
  const { documentState, actions } = useCompanyDocuments();
  const [state, dispatch] = useStore();
  const modal_actions = modalActions(state, dispatch);

  useEffect(() => {
    actions.getCompanyDocuments(company.id);
  }, []);

  const getDenominationClient = () => {
    const gender = tools.getGender(company.gender);
    const parts = [gender, company.lastname, company.firstname].filter(Boolean);
    if (company.company) {
      parts.push(`- ${company.company}`);
    }
    return parts.join(" ");
  };

  const openDERModal = () => {
    modal_actions.updateModal({
      isOpen: true,
      title: "Générer un DER",
      content: (
        <DERForm
          actions={actions}
          company={company}
          getDenominationClient={getDenominationClient}
          documentState={documentState}
        />
      ),
      contentStyle: {
        maxWidth: 550,
        maxHeight: 350,
        height: "auto",
      },
      // style: {
      //   maxWidth: 550,
      //   maxHeight: 300,
      //   position: "fixed",
      //   top: "50%",
      //   left: "50%",
      //   transform: "translate(-50%, -50%)",
      // },
    });
  };

  return (
    <div className="row">
      <div className="col-12 d-flex justify-content-end" style={{ gap: 8 }}>
        <SaveBtn
          save={() => actions.getCompanyDocuments(company.id)}
          isSaving={documentState.isLoadingDocuments}
          text={
            <>
              <i className="fa fa-refresh mr-2" />
              Rafraîchir
            </>
          }
          className="btn-sm"
          type="default"
          loaderColor="#000000"
          loadingText="Chargement..."
        />
        <SaveBtn
          save={() => actions.syncPublicDocuments(company.id)}
          isSaving={documentState.isSyncingDocuments}
          text={
            <>
              <i className="fa fa-refresh mr-2" />
              Synchroniser les documents publics
            </>
          }
          dataPriv="bo_majdocumentspublicsclient"
          className="btn-sm"
          type="default"
          loaderColor="#000000"
          loadingText="Synchronisation en cours..."
        />
      </div>
      {!documentState.isLoadingDocuments &&
        documentState.companyDocuments.map((document) => {
          return (
            <div
              className="col-12 col-md-6 col-lg-4 p-2"
              key={`docgroup${document.map((d) => d.fileType.name).join("-")}`}
            >
              <BPDocumentItem
                nbDocs={document.length}
                doc={document}
                docMeta={{
                  productName: "",
                  companyName: company?.company || "",
                }}
                docType={docType}
                renderExtra={
                  document[0]?.fileType?.code === "DER" ? (
                    <div className="d-center">
                      <SaveBtn
                        save={() => openDERModal()}
                        isSaving={documentState.isGeneratingDER}
                        text={
                          <>
                            <i className="fa fa-file-text-o mr-2" />
                            Générer DER
                          </>
                        }
                        className="btn-sm d-center rounded my-2"
                        type="primary"
                        loaderColor="#ffffff"
                        loadingText="Génération en cours..."
                      />
                    </div>
                  ) : null
                }
              />
            </div>
          );
        })}
    </div>
  );
};

export default BPDocuments;
